import * as i0 from '@angular/core';
import { PLATFORM_ID, Component, Inject, Input, Output, NgModule } from '@angular/core';
import DxDashboardControl from 'devexpress-dashboard/integration/index';
import * as i1 from 'devextreme-angular/core';
import { DxComponent, DxTemplateHost, WatcherHelper, NestedOptionHost, DxIntegrationModule, DxTemplateModule } from 'devextreme-angular/core';
import { DxoAjaxRemoteServiceModule, DxoDataRequestOptionsModule, DxoExtensionsModule, DxoChartIndicatorsModule, DxoDashboardExportModule, DxoDashboardParameterDialogModule, DxoDataInspectorModule, DxoDataSourceWizardModule, DxoWizardSettingsModule, DxoDesignerToolbarModule, DxoItemBindingPanelModule, DxoItemOptionsPanelModule, DxoMobileLayoutModule, DxoTextBoxItemEditorModule, DxoViewerApiModule, DxoFetchRemoteServiceModule } from 'devexpress-dashboard-angular/ui/nested';

/* tslint:disable:max-line-length */
/**
 * [descr:dxDashboardControl]

 */
class DxDashboardControlComponent extends DxComponent {
    instance = null;
    /**
     * [descr:dxDashboardControlOptions.ajaxRemoteService]
    
     */
    get ajaxRemoteService() {
        return this._getOption('ajaxRemoteService');
    }
    set ajaxRemoteService(value) {
        this._setOption('ajaxRemoteService', value);
    }
    /**
     * [descr:dxDashboardControlOptions.allowMaximizeItems]
    
     */
    get allowMaximizeItems() {
        return this._getOption('allowMaximizeItems');
    }
    set allowMaximizeItems(value) {
        this._setOption('allowMaximizeItems', value);
    }
    /**
     * [descr:dxDashboardControlOptions.dashboardId]
    
     */
    get dashboardId() {
        return this._getOption('dashboardId');
    }
    set dashboardId(value) {
        this._setOption('dashboardId', value);
    }
    /**
     * [descr:dxDashboardControlOptions.dataRequestOptions]
    
     */
    get dataRequestOptions() {
        return this._getOption('dataRequestOptions');
    }
    set dataRequestOptions(value) {
        this._setOption('dataRequestOptions', value);
    }
    /**
     * [descr:dxDashboardControlOptions.encodeHtml]
    
     */
    get encodeHtml() {
        return this._getOption('encodeHtml');
    }
    set encodeHtml(value) {
        this._setOption('encodeHtml', value);
    }
    /**
     * [descr:dxDashboardControlOptions.endpoint]
    
     */
    get endpoint() {
        return this._getOption('endpoint');
    }
    set endpoint(value) {
        this._setOption('endpoint', value);
    }
    /**
     * [descr:dxDashboardControlOptions.extensions]
    
     */
    get extensions() {
        return this._getOption('extensions');
    }
    set extensions(value) {
        this._setOption('extensions', value);
    }
    /**
     * [descr:dxDashboardControlOptions.fetchRemoteService]
    
     */
    get fetchRemoteService() {
        return this._getOption('fetchRemoteService');
    }
    set fetchRemoteService(value) {
        this._setOption('fetchRemoteService', value);
    }
    /**
     * [descr:dxDashboardControlOptions.initialDashboardId]
    
     */
    get initialDashboardId() {
        return this._getOption('initialDashboardId');
    }
    set initialDashboardId(value) {
        this._setOption('initialDashboardId', value);
    }
    /**
     * [descr:dxDashboardControlOptions.initialDashboardState]
    
     */
    get initialDashboardState() {
        return this._getOption('initialDashboardState');
    }
    set initialDashboardState(value) {
        this._setOption('initialDashboardState', value);
    }
    /**
     * [descr:dxDashboardControlOptions.limitVisibleDataMode]
    
     */
    get limitVisibleDataMode() {
        return this._getOption('limitVisibleDataMode');
    }
    set limitVisibleDataMode(value) {
        this._setOption('limitVisibleDataMode', value);
    }
    /**
     * [descr:dxDashboardControlOptions.loadDefaultDashboard]
    
     */
    get loadDefaultDashboard() {
        return this._getOption('loadDefaultDashboard');
    }
    set loadDefaultDashboard(value) {
        this._setOption('loadDefaultDashboard', value);
    }
    /**
     * [descr:dxDashboardControlOptions.nonce]
    
     */
    get nonce() {
        return this._getOption('nonce');
    }
    set nonce(value) {
        this._setOption('nonce', value);
    }
    /**
     * [descr:dxDashboardControlOptions.resizeByTimer]
    
     */
    get resizeByTimer() {
        return this._getOption('resizeByTimer');
    }
    set resizeByTimer(value) {
        this._setOption('resizeByTimer', value);
    }
    /**
     * [descr:dxDashboardControlOptions.showConfirmationOnBrowserClosing]
    
     */
    get showConfirmationOnBrowserClosing() {
        return this._getOption('showConfirmationOnBrowserClosing');
    }
    set showConfirmationOnBrowserClosing(value) {
        this._setOption('showConfirmationOnBrowserClosing', value);
    }
    /**
     * [descr:dxDashboardControlOptions.useNeutralFilterMode]
    
     */
    get useNeutralFilterMode() {
        return this._getOption('useNeutralFilterMode');
    }
    set useNeutralFilterMode(value) {
        this._setOption('useNeutralFilterMode', value);
    }
    /**
     * [descr:dxDashboardControlOptions.workingMode]
    
     */
    get workingMode() {
        return this._getOption('workingMode');
    }
    set workingMode(value) {
        this._setOption('workingMode', value);
    }
    /**
    
     * [descr:dxDashboardControlOptions.onBeforeRender]
    
    
     */
    onBeforeRender;
    /**
    
     * [descr:dxDashboardControlOptions.onDashboardBeginUpdate]
    
    
     */
    onDashboardBeginUpdate;
    /**
    
     * [descr:dxDashboardControlOptions.onDashboardEndUpdate]
    
    
     */
    onDashboardEndUpdate;
    /**
    
     * [descr:dxDashboardControlOptions.onDashboardInitialized]
    
    
     */
    onDashboardInitialized;
    /**
    
     * [descr:dxDashboardControlOptions.onDashboardInitializing]
    
    
     */
    onDashboardInitializing;
    /**
    
     * [descr:dxDashboardControlOptions.onDashboardStateChanged]
    
    
     */
    onDashboardStateChanged;
    /**
    
     * [descr:dxDashboardControlOptions.onInitializing]
    
    
     */
    onInitializing;
    /**
    
     * [descr:dxDashboardControlOptions.onItemBeginUpdate]
    
    
     */
    onItemBeginUpdate;
    /**
    
     * [descr:dxDashboardControlOptions.onItemEndUpdate]
    
    
     */
    onItemEndUpdate;
    /**
    
     * [descr:dxDashboardControlOptions.onOptionChanged]
    
    
     */
    onOptionChanged;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    ajaxRemoteServiceChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    allowMaximizeItemsChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    dashboardIdChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    dataRequestOptionsChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    encodeHtmlChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    endpointChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    extensionsChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    fetchRemoteServiceChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    initialDashboardIdChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    initialDashboardStateChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    limitVisibleDataModeChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    loadDefaultDashboardChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    nonceChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    resizeByTimerChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    showConfirmationOnBrowserClosingChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    useNeutralFilterModeChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    workingModeChange;
    constructor(elementRef, ngZone, templateHost, _watcherHelper, optionHost, transferState, platformId) {
        super(elementRef, ngZone, templateHost, _watcherHelper, transferState, platformId);
        this._createEventEmitters([
            { subscribe: 'beforeRender', emit: 'onBeforeRender' },
            { subscribe: 'dashboardBeginUpdate', emit: 'onDashboardBeginUpdate' },
            { subscribe: 'dashboardEndUpdate', emit: 'onDashboardEndUpdate' },
            { subscribe: 'dashboardInitialized', emit: 'onDashboardInitialized' },
            { subscribe: 'dashboardInitializing', emit: 'onDashboardInitializing' },
            { subscribe: 'dashboardStateChanged', emit: 'onDashboardStateChanged' },
            { subscribe: 'initializing', emit: 'onInitializing' },
            { subscribe: 'itemBeginUpdate', emit: 'onItemBeginUpdate' },
            { subscribe: 'itemEndUpdate', emit: 'onItemEndUpdate' },
            { subscribe: 'optionChanged', emit: 'onOptionChanged' },
            { emit: 'ajaxRemoteServiceChange' },
            { emit: 'allowMaximizeItemsChange' },
            { emit: 'dashboardIdChange' },
            { emit: 'dataRequestOptionsChange' },
            { emit: 'encodeHtmlChange' },
            { emit: 'endpointChange' },
            { emit: 'extensionsChange' },
            { emit: 'fetchRemoteServiceChange' },
            { emit: 'initialDashboardIdChange' },
            { emit: 'initialDashboardStateChange' },
            { emit: 'limitVisibleDataModeChange' },
            { emit: 'loadDefaultDashboardChange' },
            { emit: 'nonceChange' },
            { emit: 'resizeByTimerChange' },
            { emit: 'showConfirmationOnBrowserClosingChange' },
            { emit: 'useNeutralFilterModeChange' },
            { emit: 'workingModeChange' }
        ]);
        optionHost.setHost(this);
    }
    _createInstance(element, options) {
        return new DxDashboardControl(element, options);
    }
    ngOnDestroy() {
        this._destroyWidget();
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxDashboardControlComponent, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }, { token: i1.DxTemplateHost }, { token: i1.WatcherHelper }, { token: i1.NestedOptionHost }, { token: i0.TransferState }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxDashboardControlComponent, selector: "dx-dashboard-control", inputs: { ajaxRemoteService: "ajaxRemoteService", allowMaximizeItems: "allowMaximizeItems", dashboardId: "dashboardId", dataRequestOptions: "dataRequestOptions", encodeHtml: "encodeHtml", endpoint: "endpoint", extensions: "extensions", fetchRemoteService: "fetchRemoteService", initialDashboardId: "initialDashboardId", initialDashboardState: "initialDashboardState", limitVisibleDataMode: "limitVisibleDataMode", loadDefaultDashboard: "loadDefaultDashboard", nonce: "nonce", resizeByTimer: "resizeByTimer", showConfirmationOnBrowserClosing: "showConfirmationOnBrowserClosing", useNeutralFilterMode: "useNeutralFilterMode", workingMode: "workingMode" }, outputs: { onBeforeRender: "onBeforeRender", onDashboardBeginUpdate: "onDashboardBeginUpdate", onDashboardEndUpdate: "onDashboardEndUpdate", onDashboardInitialized: "onDashboardInitialized", onDashboardInitializing: "onDashboardInitializing", onDashboardStateChanged: "onDashboardStateChanged", onInitializing: "onInitializing", onItemBeginUpdate: "onItemBeginUpdate", onItemEndUpdate: "onItemEndUpdate", onOptionChanged: "onOptionChanged", ajaxRemoteServiceChange: "ajaxRemoteServiceChange", allowMaximizeItemsChange: "allowMaximizeItemsChange", dashboardIdChange: "dashboardIdChange", dataRequestOptionsChange: "dataRequestOptionsChange", encodeHtmlChange: "encodeHtmlChange", endpointChange: "endpointChange", extensionsChange: "extensionsChange", fetchRemoteServiceChange: "fetchRemoteServiceChange", initialDashboardIdChange: "initialDashboardIdChange", initialDashboardStateChange: "initialDashboardStateChange", limitVisibleDataModeChange: "limitVisibleDataModeChange", loadDefaultDashboardChange: "loadDefaultDashboardChange", nonceChange: "nonceChange", resizeByTimerChange: "resizeByTimerChange", showConfirmationOnBrowserClosingChange: "showConfirmationOnBrowserClosingChange", useNeutralFilterModeChange: "useNeutralFilterModeChange", workingModeChange: "workingModeChange" }, providers: [
            DxTemplateHost,
            WatcherHelper,
            NestedOptionHost
        ], usesInheritance: true, ngImport: i0, template: '', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxDashboardControlComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'dx-dashboard-control',
                    template: '',
                    providers: [
                        DxTemplateHost,
                        WatcherHelper,
                        NestedOptionHost
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }, { type: i1.DxTemplateHost }, { type: i1.WatcherHelper }, { type: i1.NestedOptionHost }, { type: i0.TransferState }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { ajaxRemoteService: [{
                type: Input
            }], allowMaximizeItems: [{
                type: Input
            }], dashboardId: [{
                type: Input
            }], dataRequestOptions: [{
                type: Input
            }], encodeHtml: [{
                type: Input
            }], endpoint: [{
                type: Input
            }], extensions: [{
                type: Input
            }], fetchRemoteService: [{
                type: Input
            }], initialDashboardId: [{
                type: Input
            }], initialDashboardState: [{
                type: Input
            }], limitVisibleDataMode: [{
                type: Input
            }], loadDefaultDashboard: [{
                type: Input
            }], nonce: [{
                type: Input
            }], resizeByTimer: [{
                type: Input
            }], showConfirmationOnBrowserClosing: [{
                type: Input
            }], useNeutralFilterMode: [{
                type: Input
            }], workingMode: [{
                type: Input
            }], onBeforeRender: [{
                type: Output
            }], onDashboardBeginUpdate: [{
                type: Output
            }], onDashboardEndUpdate: [{
                type: Output
            }], onDashboardInitialized: [{
                type: Output
            }], onDashboardInitializing: [{
                type: Output
            }], onDashboardStateChanged: [{
                type: Output
            }], onInitializing: [{
                type: Output
            }], onItemBeginUpdate: [{
                type: Output
            }], onItemEndUpdate: [{
                type: Output
            }], onOptionChanged: [{
                type: Output
            }], ajaxRemoteServiceChange: [{
                type: Output
            }], allowMaximizeItemsChange: [{
                type: Output
            }], dashboardIdChange: [{
                type: Output
            }], dataRequestOptionsChange: [{
                type: Output
            }], encodeHtmlChange: [{
                type: Output
            }], endpointChange: [{
                type: Output
            }], extensionsChange: [{
                type: Output
            }], fetchRemoteServiceChange: [{
                type: Output
            }], initialDashboardIdChange: [{
                type: Output
            }], initialDashboardStateChange: [{
                type: Output
            }], limitVisibleDataModeChange: [{
                type: Output
            }], loadDefaultDashboardChange: [{
                type: Output
            }], nonceChange: [{
                type: Output
            }], resizeByTimerChange: [{
                type: Output
            }], showConfirmationOnBrowserClosingChange: [{
                type: Output
            }], useNeutralFilterModeChange: [{
                type: Output
            }], workingModeChange: [{
                type: Output
            }] } });
class DxDashboardControlModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxDashboardControlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxDashboardControlModule, declarations: [DxDashboardControlComponent], imports: [DxoAjaxRemoteServiceModule,
            DxoDataRequestOptionsModule,
            DxoExtensionsModule,
            DxoChartIndicatorsModule,
            DxoDashboardExportModule,
            DxoDashboardParameterDialogModule,
            DxoDataInspectorModule,
            DxoDataSourceWizardModule,
            DxoWizardSettingsModule,
            DxoDesignerToolbarModule,
            DxoItemBindingPanelModule,
            DxoItemOptionsPanelModule,
            DxoMobileLayoutModule,
            DxoTextBoxItemEditorModule,
            DxoViewerApiModule,
            DxoFetchRemoteServiceModule,
            DxIntegrationModule,
            DxTemplateModule], exports: [DxDashboardControlComponent, DxoAjaxRemoteServiceModule,
            DxoDataRequestOptionsModule,
            DxoExtensionsModule,
            DxoChartIndicatorsModule,
            DxoDashboardExportModule,
            DxoDashboardParameterDialogModule,
            DxoDataInspectorModule,
            DxoDataSourceWizardModule,
            DxoWizardSettingsModule,
            DxoDesignerToolbarModule,
            DxoItemBindingPanelModule,
            DxoItemOptionsPanelModule,
            DxoMobileLayoutModule,
            DxoTextBoxItemEditorModule,
            DxoViewerApiModule,
            DxoFetchRemoteServiceModule,
            DxTemplateModule] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxDashboardControlModule, imports: [DxoAjaxRemoteServiceModule,
            DxoDataRequestOptionsModule,
            DxoExtensionsModule,
            DxoChartIndicatorsModule,
            DxoDashboardExportModule,
            DxoDashboardParameterDialogModule,
            DxoDataInspectorModule,
            DxoDataSourceWizardModule,
            DxoWizardSettingsModule,
            DxoDesignerToolbarModule,
            DxoItemBindingPanelModule,
            DxoItemOptionsPanelModule,
            DxoMobileLayoutModule,
            DxoTextBoxItemEditorModule,
            DxoViewerApiModule,
            DxoFetchRemoteServiceModule,
            DxIntegrationModule,
            DxTemplateModule, DxoAjaxRemoteServiceModule,
            DxoDataRequestOptionsModule,
            DxoExtensionsModule,
            DxoChartIndicatorsModule,
            DxoDashboardExportModule,
            DxoDashboardParameterDialogModule,
            DxoDataInspectorModule,
            DxoDataSourceWizardModule,
            DxoWizardSettingsModule,
            DxoDesignerToolbarModule,
            DxoItemBindingPanelModule,
            DxoItemOptionsPanelModule,
            DxoMobileLayoutModule,
            DxoTextBoxItemEditorModule,
            DxoViewerApiModule,
            DxoFetchRemoteServiceModule,
            DxTemplateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxDashboardControlModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        DxoAjaxRemoteServiceModule,
                        DxoDataRequestOptionsModule,
                        DxoExtensionsModule,
                        DxoChartIndicatorsModule,
                        DxoDashboardExportModule,
                        DxoDashboardParameterDialogModule,
                        DxoDataInspectorModule,
                        DxoDataSourceWizardModule,
                        DxoWizardSettingsModule,
                        DxoDesignerToolbarModule,
                        DxoItemBindingPanelModule,
                        DxoItemOptionsPanelModule,
                        DxoMobileLayoutModule,
                        DxoTextBoxItemEditorModule,
                        DxoViewerApiModule,
                        DxoFetchRemoteServiceModule,
                        DxIntegrationModule,
                        DxTemplateModule
                    ],
                    declarations: [
                        DxDashboardControlComponent
                    ],
                    exports: [
                        DxDashboardControlComponent,
                        DxoAjaxRemoteServiceModule,
                        DxoDataRequestOptionsModule,
                        DxoExtensionsModule,
                        DxoChartIndicatorsModule,
                        DxoDashboardExportModule,
                        DxoDashboardParameterDialogModule,
                        DxoDataInspectorModule,
                        DxoDataSourceWizardModule,
                        DxoWizardSettingsModule,
                        DxoDesignerToolbarModule,
                        DxoItemBindingPanelModule,
                        DxoItemOptionsPanelModule,
                        DxoMobileLayoutModule,
                        DxoTextBoxItemEditorModule,
                        DxoViewerApiModule,
                        DxoFetchRemoteServiceModule,
                        DxTemplateModule
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DxDashboardControlComponent, DxDashboardControlModule };
